// src/components/UploadWorkspace/YTVideoDisplay.jsx
import React, { useState, useEffect } from 'react';
import VideoPreview from './VideoPreview';
import link_icon from '../../../../assets/images/icons/link-icon.png';
import './linkWorkspace.css';

const YTVideoDisplay = ({ workspaceVideoDetails = {}, doneVideos }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { videoId, thumbnailUrl } = workspaceVideoDetails;
  const done = videoId && doneVideos.includes(videoId);

  // Once we get a videoId, stop showing the skeleton
  useEffect(() => {
    if (videoId) {
      setIsLoading(false);
    }
  }, [videoId]);

  // Shimmer‐skeleton UI while loading
if (isLoading) {
  return (
    <section className="worklink-urlinput-section">
      <div className="link-skeleton link-skeleton-input" />
    </section>
  );
}


  // Final display once data is ready
  return (
    <>
      {/* 1) URL Input + “View Video” */}
      <section className="worklink-urlinput-section">
        <div className="worklink-urlinput-container">
          <div className="worklink-input-icon-wrapper">
            <img
              src={link_icon}
              alt="Link Icon"
              className="worklink-url-input-icon"
            />
            <input
              type="text"
              className="worklink-input-icon-wrapper-DONE"
              value={`https://youtu.be/${videoId}`}
              disabled
            />
          </div>

          <div>
            {done && (
              <a
                href={`https://youtu.be/${videoId}`}
                target="_blank"
                rel="noopener noreferrer"
                className="worklink-url-input-button videoDataReady"
              >
                View Video
              </a>
            )}
          </div>
        </div>
      </section>

      {/* 2) Thumbnail + Title */}
      {thumbnailUrl && (
        <VideoPreview
          details={workspaceVideoDetails}
          isProcessing={false}
          errorMessage={null}
          isTranscriptError={false}
          done={done}
        />
      )}
    </>
  );
};

export default YTVideoDisplay;
